module.exports = __webpack_public_path__ + "img/sponsorsships-of-fundacio-mallorca-turisme.ef8c16a2.jpg";